import { createContext, useContext, useState, useEffect } from "react";
import { setToken } from "../utils/browserSetting";
const UserContext = createContext();
const Provider = UserContext.Provider;

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isSimpleUser, setIsSimpleUser] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("zoomuser");
    const userJson = JSON.parse(storedUser);
    if (storedUser) {
      console.log("storedUser", userJson);
      setUser(JSON.parse(storedUser));
      setIsSimpleUser(userJson.userType == 0);
    }
  }, []);
  
  const updateUser = (userData) => {
    setUser(userData);
    setToken(userData.token);
    localStorage.setItem("zoomuser", JSON.stringify(userData));
  };

  const resetUser = () => {
    setUser(null);
    setIsSimpleUser(false);
    localStorage.removeItem("zoomuser");
    localStorage.removeItem("token");
  };

  return (
    <Provider
      value={{
        user,
        setUser: updateUser,
        resetUser,
        isSimpleUser,
        setIsSimpleUser,
      }}
    >
      {children}
    </Provider>
  );
};

export const useUser = () => useContext(UserContext);
